/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiPoseFromJSON, StreemApiPoseToJSON, } from './';
export function StaticAnchorFromJSON(json) {
    return StaticAnchorFromJSONTyped(json, false);
}
export function StaticAnchorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'anchorId': !exists(json, 'anchor_id') ? undefined : json['anchor_id'],
        'pose': !exists(json, 'pose') ? undefined : StreemApiPoseFromJSON(json['pose']),
    };
}
export function StaticAnchorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'anchor_id': value.anchorId,
        'pose': StreemApiPoseToJSON(value.pose),
    };
}
//# sourceMappingURL=StaticAnchor.js.map